<template>
    <div class="wrap">
        <div class="case">
            <div class="title">
                <span>病例</span>
            </div>

            <div class="item-work">
                <span>姓名</span>
                <span>{{work.name}}</span>
            </div>

            <div class="item-work">
                <span>导师</span>
                <span>{{work.tutor}}</span>
            </div>

            <div class="item-work">
                <span>题目</span>
                <span>{{work.title}}</span>
            </div>

            <div class="item-work">
                <span>病例</span>
                <a :href="work.href">点击查看</a>
            </div>

        </div>

        <div class="score">

            <div class="title">
                <span>评审</span>
            </div>

            <div class="item">
                <div class="item_title">
                    <div class="item_title_index">
                        <label>1</label>
                    </div>
                    <span>{{score1_title}}</span>
                </div>

                <div class="item_score">
                    <label>{{score1_exp}}</label>
                    <input type="number" v-model="score.score1" max="25" pattern="[0-9]*" readonly @click="showScorePopup(1)">
                    <span>分</span>
                </div>
            </div>

            <div class="item">
                <div class="item_title">
                    <div class="item_title_index">
                        <label>2</label>
                    </div>
                    <span>{{score2_title}}</span>
                </div>

                <div class="item_score">
                    <label>{{score2_exp}}</label>
                    <input type="number" v-model="score.score2" max="15" pattern="[0-9]*" readonly @click="showScorePopup(2)">
                    <span>分</span>
                </div>
            </div>

            <div class="item">
                <div class="item_title">
                    <div class="item_title_index">
                        <label>3</label>
                    </div>
                    <span>{{score3_title}}</span>
                </div>

                <div class="item_score">
                    <label>{{score3_exp}}</label>
                    <input type="number" v-model="score.score3" max="15" pattern="[0-9]*" readonly @click="showScorePopup(3)">
                    <span>分</span>
                </div>
            </div>

            <div class="item">
                <div class="item_title">
                    <div class="item_title_index">
                        <label>4</label>
                    </div>
                    <span>{{score4_title}}</span>
                </div>

                <div class="item_score">
                    <label>{{score4_exp}}</label>
                    <input type="number" v-model="score.score4" max="20" pattern="[0-9]*" readonly @click="showScorePopup(4)">
                    <span>分</span>
                </div>
            </div>

            <div class="item">
                <div class="item_title">
                    <div class="item_title_index">
                        <label>5</label>
                    </div>
                    <span>{{score5_title}}</span>
                </div>
                <div class="item_score">
                    <label>{{score5_exp}}</label>
                    <input type="number" v-model="score.score5" max="25" pattern="[0-9]*" readonly @click="showScorePopup(5)">
                    <span>分</span>
                </div>
            </div>

            <div class="item_score_all">
                <input type="number" v-model="allScore" readonly>
                <span>总分</span>
            </div>

            <div class="item_score_comment">
                <span>专家评审意见</span>
                <div class="item_score_comment_input">
                    <div class="a">
                    <textarea placeholder="请填写评语，不少于30字数" v-model="score.comment">
                    </textarea>
                        <div class="comment-number">
                            {{score.comment.length}}/30
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="submit" @click="submit">
            <span>提交</span>
        </div>

        <mt-popup class="popup" v-model="scorePopupVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom">
            <mt-picker :slots="scoreSlots" @change="scoreValuesChange" showToolbar>
                <div class="picker-toolbar-title">
                    <div class="usi-btn-cancel" @click="scorePopupVisible = !scorePopupVisible">取消</div>
                    <div class="">请打分</div>
                    <div class="usi-btn-sure" @click="scoreValueAdd">确定</div>
                </div>
            </mt-picker>
        </mt-popup>

    </div>
</template>

<script>

    import {wxScoreCase,getCaseScore} from "@/assets/js/api";

    export default {
        name: '',
        data() {
            return {
                btnSubmit:"提交",
                score1_title:"主题突出(25分)",
                score1_exp:"病例紧紧围绕西格列他钠改善胰岛素抵抗对T2DM的临床获益这一角度展开，观察西格列他钠对糖脂能量代谢的疗效及安全性",
                score2_title:"信息充分(15分)",
                score2_exp:"病情描述清晰，完整，需包含一般项目、主诉、病史、查体、辅助检查、诊断、治疗方案、随访结果或调整方案等",
                score3_title:"诊断准确(15分)",
                score3_exp:"诊断和鉴别诊断思路明确、清晰、有逻辑",
                score4_title:"方案合理(20分)",
                score4_exp:"治疗方案的选择依据充分，临床疗效明确，达到治疗预期",
                score5_title:"病例总结(25分)",
                score5_exp:"对诊疗过程有深刻思考，有独到见解和有启示及教育意义的总结，充分阐述新一代胰岛素增敏剂西格列他钠对T2DM的治疗所带来的进展及突破",
                comment:"",
                commentNumber:0,
                score:{
                    score1:"",
                    score2:"",
                    score3:"",
                    score4:"",
                    score5:"",
                    comment:"",
                    caseId:this.$route.query.caseId,
                    judgeId:this.$route.query.judgeId
                },
                work:{
                    name:"",
                    tutor:"",
                    title:"",
                    href:""
                },

                scorePopupVisible:false,
                scoreSlots: [{
                    values: [],
                }],
                scoreSure:"",
                scoreIndex:0
            }
        },
        computed:{
            allScore() {
                let score1 = this.score.score1==""?0:parseInt(this.score.score1)
                let score2 = this.score.score2==""?0:parseInt(this.score.score2)
                let score3 = this.score.score3==""?0:parseInt(this.score.score3)
                let score4 = this.score.score4==""?0:parseInt(this.score.score4)
                let score5 = this.score.score5==""?0:parseInt(this.score.score5)
                return score1 + score2 + score3 + score4 + score5
            }
        },
        mounted(){
            this.getCaseScore(this.score.caseId,this.score.judgeId);
        },
        methods: {
            showScorePopup(index){
                this.scorePopupVisible = true
                this.scoreIndex = index
                var maxScoreNumber = 20;
                this.scoreSlots[0].values = []
                switch (index) {
                    case 1:
                        maxScoreNumber = 25
                        break
                    case 2:
                        maxScoreNumber = 15
                        break
                    case 3:
                        maxScoreNumber = 15
                        break
                    case 4:
                        maxScoreNumber = 20
                        break
                    case 5:
                        maxScoreNumber = 25
                        break
                }

                for (var i =0;i<=maxScoreNumber;i++){
                    this.scoreSlots[0].values.push(i)
                }

            },
            scoreValuesChange(picker, values) {
                this.scoreSure = values[0];
            },
            scoreValueAdd(){
                this.scorePopupVisible = !this.scorePopupVisible
                switch (this.scoreIndex) {
                    case 1:
                        this.score.score1 = this.scoreSure;
                        break
                    case 2:
                        this.score.score2 = this.scoreSure;
                        break
                    case 3:
                        this.score.score3 = this.scoreSure;
                        break
                    case 4:
                        this.score.score4 = this.scoreSure;
                        break
                    case 5:
                        this.score.score5 = this.scoreSure;
                        break
                }
            },
            async getCaseScore(caseId,judgeId){
                let res = await getCaseScore({caseId,judgeId})
                console.log(res)
                this.work = res.data.data.case
                if(res.data.data.score!=null&&res.data.data.score!=''){
                    this.score = res.data.data.score
                }
            },
            submit:function () {
                if(this.score.score1==''||this.score.score1<0||this.score.score1>25){
                    this.$toast("主题突出打分0~25之间")
                    return
                }
                if(this.score.score2==''||this.score.score2<0||this.score.score2>15){
                    this.$toast("信息充分打分0~15之间")
                    return
                }
                if(this.score.score3==''||this.score.score3<0||this.score.score3>15){
                    this.$toast("诊断准确打分0~15之间")
                    return
                }
                if(this.score.score4==''||this.score.score4<0||this.score.score4>20){
                    this.$toast("方案合理打分0~20之间")
                    return
                }
                if(this.score.score5==''||this.score.score5<0||this.score.score5>25){
                    this.$toast("病例总结打分0~25之间")
                    return
                }
                if(this.score.comment==''||this.score.comment.length<30){
                    this.$toast("评论字数不能小于30")
                    return;
                }
                this.addScore(this.score)
            },
            async addScore(score){
                const res = await wxScoreCase({score});
                if(res.data.success==true){
                    this.$toast("提交成功")

                    this.$router.replace({path:"/wx_judge_index",query:{judgeId:this.score.judgeId}})

                }else {
                    this.$toast(res.data.message)
                }
                console.log(res)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .wrap {
        background: #FFF;
        width: 100%;
        max-width: 500px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        overflow: auto;
    }

    .kv{
        width: 100%;
        /*height: 100vw;*/
        padding: 56.25% 0 0;
        background: #FFF url("../../assets/img/wx_kv.jpg") no-repeat;
        background-size: 100% 100% ;
    }

    .item{
        text-align: left;
        margin-top: 10px;
        .item_title{
            width: 95%;
            padding: 2px;
            background: #0082c5;
            border-radius: 10px;
            margin:auto;
            color: #FFF;
            display: flex;
            flex-direction: row;
            justify-content: start;
            align-items: center;
            .item_title_index{
                background: #ef4f4f;
                width: 22px;
                height: 22px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 15px;
                margin: 0 10px;
            }
            span{
                font-size: 18px;
                font-weight: bold;
                display: inline-block;
                text-align: center;
            }
        }
        .item_score{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 10px 0 0 10px;
            font-size: 15px;
            label{
                width: 90%;
            }
            input{
                /*margin: 0 10px;*/
                margin-left: 10px;
                text-indent: 10px;
                display: block;
                width: 10%;
                height: 20px;
                border-left: #FFF;
                border-right: #FFF;
                border-top: #FFF;
                border-radius: 0;
                border-bottom: red solid 1px;
                outline: none;
                font-size: 20px;
            }
        }
    }

    .item_score_all{
        display: flex;
        flex-direction: row-reverse;
        font-size: 22px;
        font-weight: bold;
        color: #ef4f4f;
        input{
            margin-right: 10px;
            width: 50px;
            text-indent: 10px;
            border-left: #FFF;
            border-right: #FFF;
            border-top: #FFF;
            border-radius: 0;
            border-bottom: red solid 1px;
            font-size: 25px;
        }
    }

    .item_score_comment{
        display: flex;
        flex-direction: column;
        width: 100%;
        text-align: left;
        color: #ef4f4f;
        font-size: 22px;
        span{
            margin-left: 10px;
        }
        textarea{
            width: 100%;
            height: 150px;
            background: #dedede;
            outline: none;
            border: none;
            font-size: 15px;
        }
    }

    .item_score_comment_input{
        display: flex;
        justify-content: center;
    }

    .submit{
        width: 90%;
        background: #0082c5;
        margin: 50px auto;
        padding: 2px 0;
        font-size: 25px;
        color: #FFF;
        border-radius: 20px;
    }

    .comment-number{
        position: absolute;
        right: 2px;
        bottom: 2px;
    }

    .a{
        width: 95%;
        margin: 10px auto;
        position: relative;
    }

    .item-work{
        display: flex;
        justify-content: start ;
        font-size: 20px;
        margin-left: 10px;
        span{
            margin-right: 20px;
        }
    }

    .title{
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        margin: 10px 0;
        padding: 5px 10px;
        background: #e0e0e0;
    }

    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }

    .usi-btn-cancel,
    .usi-btn-sure {
        color: #0082C5;
    }

    .popup{
        width: 100%;
    }


</style>
